export const LOIN_REQUEST_SUCCESS = 'LOIN_REQUEST_SUCCESS';
export const REMOVE_COOKIE = 'REMOVE_COOKIE';
export const PRE_REQUEST = 'PRE_REQUEST';
export const LOAD_DATA_SUCCESS = 'LOAD_DATA_SUCCESS';
export const SEND_DATA = 'SEND_DATA';
export const UPDATE_DATA = 'UPDATE_DATA';
export const DELETE_DATA = 'DELETE_DATA';
export const ERROR = 'ERROR';